import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

export const BackButton = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return location.key !== "default" ? (
    <button onClick={() => navigate(-1)}>⟵ Back</button>
  ) : (
    <></>
  );
};
